import { Button } from "@asosteam/asos-web-component-library-button";
import styles from "./styles";
import { isTemporarilyClosed } from "../../utilities/competition-status";

const CompetitionClosed = () => {
  const temporarilyClosed = isTemporarilyClosed();
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <h2 className="app_barnsley5">
          COMPETITION CLOSED!{temporarilyClosed && " RETURN NEXT WEEK"}
        </h2>
        <p className="app_leavesden1">
          {temporarilyClosed
            ? "You just missed out but come back next week to be in with a chance to win."
            : "Sorry, this competition has now closed."}
        </p>
        <div>
          <Button elementOverride="a" href="/women">
            Shop Women
          </Button>
          <Button elementOverride="a" href="/men">
            Shop Men
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CompetitionClosed;
